export default __webpack_public_path__ + "static/home0-45a9a04e8a33c95fa7bbf2b31edabee6.webm";